// src/router/grupos.js

// Quem abre estas telas (TRI-107; o admin passa). Aplicado pelo guard de @/router/permissoes.js,
// que o menu lateral também usa.
const ROLES = ['admin']

const gruposBreadCrumb = [
    {
        label: 'Home',
        to: 'Home'
    },
    {
        label: 'Grupos',
        to: 'Grupos'
    }
]

export default [
    {
        path: '/grupos',
        name: 'Grupos',
        component: () => import('@/views/Grupos/GrupoListPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Grupos',
            breadcrumb: gruposBreadCrumb
        },
    },
    {
        path: '/grupos/novo',
        name: 'GrupoNovo',
        component: () => import('@/views/Grupos/NovoGrupoPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Novo Grupo',
            breadcrumb: [
                ...gruposBreadCrumb,
                {
                    label: 'Novo Cliente',
                    to: 'ClienteNovo'
                }
            ]
        }
    },
    {
        path: '/grupos/:id/edit',
        name: 'GrupoEdit',
        component: () => import('@/views/Grupos/NovoGrupoPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Detalhes do Cliente',
            breadcrumb: [
                ...gruposBreadCrumb,
                {
                    label: 'Novo Grupo',
                    to: 'GrupoNovo'
                }
            ]
        }
    }

];
